module.exports = __webpack_public_path__ + "static/media/duck.bcc49476.svg";